import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const POPUP_BUTTON_WIDTH = '45%';
export const BUTTON_TYPE_PRIMARY = 'primary';

const BREAKPOINT = '@media (max-width: 1280px)';
const COLOR_ACTIVE = '#15A250';
const COLOR_INACTIVE = COLORS.TextPrimary;

export const TariffCard = styled.div`
    width: 100%;
    border-radius: 4px;
    padding: 52px;

    @media(max-width: 768px) {
        padding: 24px;
        margin-top: 12px;
    }
`;

export const TariffInfoWrapper = styled.div`
    width: calc(100% - 296px);
    flex-direction: column;
    padding-right: 120px;

    ${BREAKPOINT} {
        width: 100%;
        padding-right: 0;
    }
`;

export const TariffConnectWrapper = styled.div`
    flex-direction: column;
    padding-top: 40px;
    width: 296px;
`;

export const TariffTitleWrapper = styled.div`
    margin-bottom: 16px;
    height: 24px;

    @media(max-width: 768px) {
        height: auto;
    }
`;

export const TariffLabel = styled.span<{ isActive: boolean }>`
    ${FONTS.XS};
    color: ${COLORS.TextWhite};

    background: ${props => props.isActive ? COLOR_ACTIVE : COLOR_INACTIVE};
    border-radius: 12px;

    padding: 2px 8px;
    margin-right: 8px;
`;

export const TariffTitle = styled.span<{ isActive: boolean }>`
    ${FONTS.S};
    color: ${props => props.isActive ? COLOR_ACTIVE : COLOR_INACTIVE};

    margin-right: 8px;
`;

export const TariffDate = styled.span`
    margin-left: 120px;
    ${FONTS.XS};
    color: ${COLOR_ACTIVE};

    @media (max-width: 768px) {
      margin-left: 0;
    }
`;

export const TariffDescription = styled.div`
    ${FONTS.L};
    color: ${COLORS.TextPrimary};
    white-space: pre-wrap;

    ${BREAKPOINT} {
      white-space: normal;
    }

    @media(max-width: 768px) {
        ${FONTS.S};
    }
`;

export const TariffPrice = styled.div`
    ${FONTS.H3};
    color: ${COLORS.TextPrimary};

    margin-bottom: 8px;
`;

export const TariffPriceNote = styled.div`
    ${FONTS.XS};
    color: ${COLORS.TextPrimary};

    margin-bottom: 16px;
`;

export const Button = styled(BaseButton)<{ width: string }>`
    width: ${props => props.width || '100%'};
`;

export const PopupContainer = styled.div`
    display: block;
    padding: 35px 60px;
    max-width: 840px;
    ${FONTS.S};
    background: ${COLORS.BgMain};
    ${BREAKPOINT} {
        padding: 35px 30px;
    }
`;

export const PopupHeader = styled.h2`
    ${FONTS.H2};
    margin-bottom: 15px;
    ${BREAKPOINT} {
        ${FONTS.H3};
        margin-bottom: 10px;
    }
`;
export const PopupButtonsWrapper = styled.div`
    justify-content: space-between;
`;

export const Paragraph = styled.div`
    margin-bottom: 16px;
`;

export const Text = styled.span``;

export const TextBold = styled.span`
    ${FONTS.H4};
`;
